import { TimelineMax } from "gsap";
import { SplashButton, SplashButtonType } from "./modules/SplashButton";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { StageEvent } from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameModuleConfig } from "../../../PunkGameModuleConfig";
import { SplashViewExpanding} from "./views/SplashViewExpanding";
import { SplashViewExtraWild} from "./views/SplashViewExtraWild";
import { SplashViewMultiplier} from "./views/SplashViewMultiplier";
import { SplashViewFreeSpins} from "./views/SplashViewFreeSpins";
import { SplashViewFullHouse} from "./views/SplashViewFullHouse";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

export interface SplashView{
    play():TimelineMax;
    stop():TimelineMax;
}

export class SplashController {
    
    protected static _instance:SplashController;
    // protected _txt:SplashText;
    protected _button:SplashButton;
    protected _button_Left:SplashButton;
    protected _button_Right:SplashButton;

    protected buttons:SplashButton[] = [];

    protected _indx:number = 0;

    protected readonly DEFAULT_TEXT: string = "It's time for Bonus!";
    
    protected readonly DEFAULT_TXT_STYLE = {
        fontWeight : FontWeight.BOLD,
        fontFamily: "Helvetica",
        align: "center",
        fill: "#ffffff",
        fontSize: 34,
        wordWrap: true,
        wordWrapWidth: 500,
        
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
    };
    

    protected readonly DEFAULT_TXT_STYLE_2 = {
        fontWeight : FontWeight.BOLD,
        fontFamily: "Helvetica",
        align: "left",
        fill: "#ffffff",
        fontSize: 34,
        wordWrap: true,
        wordWrapWidth: 500,
        
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
    };


    protected _views:SplashView[] = [];

    protected _timeLine:TimelineMax;
    protected scrollTimer:TimelineMax;

    public static get instance():SplashController{
        return this._instance;
    }

    public get button():SplashButton{ return this._button; }

    constructor(){
        SplashController._instance = this;
        this.addBaseEventListeners();
        this.createModules();
    }

    protected createModules():void{
        this._button = new SplashButton(() => EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP)));
        this._button_Left = new SplashButton(() => this.changeView(this._indx-1),SplashButtonType.LEFT);
        this._button_Right = new SplashButton(() => this.changeView(this._indx+1),SplashButtonType.RIGHT);

        this.buttons.push(this._button);
        this.buttons.push(this._button_Left);
        this.buttons.push(this._button_Right);

        StageManager.getLayer(PunkGameConfig.instance.LAYERS.BUTTON.name).addChild(this._button);
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.BUTTON.name).addChild(this._button_Left);
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.BUTTON.name).addChild(this._button_Right);
        this._views.push(new SplashViewMultiplier(this.DEFAULT_TXT_STYLE));
        this._views.push(new SplashViewFreeSpins(this.DEFAULT_TXT_STYLE));
        this._views.push(new SplashViewExpanding(this.DEFAULT_TXT_STYLE_2));
        this._views.push(new SplashViewExtraWild(this.DEFAULT_TXT_STYLE));
        this._views.push(new SplashViewFullHouse(this.DEFAULT_TXT_STYLE));
    }

    protected changeView(indx:number,timer:number = 5){
        if(indx < 0) indx = this._views.length-1;

        const oldIndx:number = this._indx;
        this._indx = indx%this._views.length;
        Helper.timeLineKiller(this.scrollTimer);
        this._views[oldIndx].stop();
        this._views[this._indx].play();

        this.scrollTimer = new TimelineMax({onComplete: () => { this.changeView(this._indx+1)} })
        PunkGameModuleConfig.xWayCounter.showGlowPositions([oldIndx],false,0.5);
        PunkGameModuleConfig.xWayCounter.showGlowPositions([this._indx],true,0.5);
        this.scrollTimer.to(this,timer,{});
    }

    public playRestore(duration:number = 1000000000000):TimelineMax{
        this._timeLine = new TimelineMax();
        for(let b:number = 0; b < this.buttons.length; b++) this._timeLine.add(this.buttons[b].showButton(duration),0);
        return this._timeLine;
    }

    public stop():void{
        Helper.timeLineKiller(this._timeLine);
        Helper.timeLineKiller(this.scrollTimer);
        this.buttons.forEach(btn => { btn.visible = false });
        this._views[this._indx].stop();
        PunkGameModuleConfig.xWayCounter.showGlowPositions([0,1,2,3,4,5],false,0.3);
    }
    
    protected addBaseEventListeners():void {
        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, () => this.onResize());
    }

    public Play(duration?:number):TimelineMax{
        this._timeLine = new TimelineMax();
        for(let b:number = 0; b < this.buttons.length; b++) this._timeLine.add(this.buttons[b].showButton(duration),0);
        this._timeLine.add(() => this.changeView(0),0);
        return this._timeLine;
    }

    public onResize():void{
        this.buttons.forEach(btn => { btn.onResize() });
    }
}
